import { Bar } from "react-chartjs-2";

export default function MetaMomentumChart({ metaDisplay }) {
  const data = {
    labels: ["MetaMomentum"],
    datasets: [
      {
        label: "Score",
        data: [metaDisplay],
        backgroundColor:
          metaDisplay <= 40
            ? "#FF0000" // vermelho (baixo)
            : metaDisplay <= 70
            ? "#007BFF" // azul (médio)
            : "#00FF66", // verde (alto)
      },
    ],
  };

  const options = {
    scales: {
      y: {
        min: 0,
        max: 100,
        title: { display: true, text: "Score (0-100)", color: "#fff" },
        ticks: { color: "#fff" },
        grid: { color: "#1A1F2E" },
      },
      x: {
        ticks: { color: "#fff" },
        grid: { color: "#1A1F2E" },
      },
    },
    plugins: {
      title: {
        display: true,
        text: "MetaMomentum Normalizado",
        color: "#00FF66",
        font: { size: 16, weight: "bold" },
      },
      legend: { labels: { color: "#fff" } },
    },
  };

  return <Bar data={data} options={options} />;
}
